import * as React from "react";

const Circle: React.FC = () => {
    return (
        <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="2.5" cy="2.5" r="2.5" fill="#0D3F6D" />
        </svg>
    );
};

export default React.memo(Circle);
